import { component } from 'picoapp'
import $ from 'quantdom'

export default component((node) => {
  try {
    const toggleChat = () => {
      // The "action" variable is retrieved from the data-action attribute of the HTML node associated with the chat toggle
      // button. This attribute is expected to contain either "open" or "close", indicating the desired action to be taken.
      const action = $(node).attr('data-action')

      Kustomer[action]()
      $(node).attr('data-action', `${action === 'open' ? 'close' : 'open'}`)
      $(node).attr('aria-label', `${action === 'open' ? 'Close' : 'Open'} Chat`)
      $(node).attr('aria-expanded', `${action === 'open' ? 'true' : 'false'}`)
    }

    // 'hidden' and 'disabled' are hard codded because Kustomer.isChatAvailable() returns { availability: String }
    // Availability Types Documentation
    // https://developer.kustomer.com/chat-sdk/v2.0-Web/docs/kustomer-is-chat-available
    const { availability } = Kustomer.isChatAvailable()
    if (availability !== 'hidden' && availability !== 'disabled') {
      $(node).attr('aria-disabled', 'false')
      $(node).attr('aria-label', 'Open Chat')
      $(node).on('click', toggleChat)
    }

    return () => {
      $(node).off('click', toggleChat)
    }
  } catch (e) {
    console.error(e)
  }
})
